export const TTN_IS_ALREADY_USED = "EB00001"
export const INVALID_TTN_FORMAT = "EB00002"
export const CLOSE_ORDER_IN_DAY_OF_SHIPPING = "EB00003"
